import React from 'react';
import './Partnership.css';
import boardroomImage from '../assets/YOCILAB/Board room.11ff75e0c48c951770f2.jpg';

const Partnership = () => {
  const collaborationPoints = [
    {
      title: "Proven Model",
      description: "Hundreds of young people trained, mentored and supported",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: "Local + Global Impact",
      description: "We work within communities but create global impact",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M2 12H22" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      )
    },
    {
      title: "Partnership-Driven",
      description: "We collaborate with schools, businesses and institutions",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M6 21V19C6 16.7909 7.79086 15 10 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
          <path d="M18 21V19C18 16.7909 16.2091 15 14 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
        </svg>
      )
    },
    {
      title: "Dynamic Team",
      description: "Our programs are delivered by a dynamic team of experts",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M23 21V19C23 17.1362 21.7252 15.5701 20 15.126" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3.12598C17.7252 3.56986 19 5.13616 19 7C19 8.86384 17.7252 10.4301 16 10.874" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  return (
    <section className="partnership">
      <div className="container">
        <div className="section-header">
          <span className="section-label">BE PART OF THE CHANGE</span>
          <h2 className="section-title">
            We don't work in a vacuum.<br />
            We co-design with partners<br />
            and young people like you.
          </h2>
        </div>

        <div className="partnership-content">
          <div className="video-section">
            <div className="video-placeholder">
              <img src={boardroomImage} alt="Boardroom collaboration" />
              <button className="play-button">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5V19L19 12L8 5Z"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="collaboration-section">
            <div className="video-caption">
              <h3>Why and how to collaborate with us</h3>
            </div>
            <div className="collaboration-points">
              {collaborationPoints.map((point, index) => (
                <div key={index} className="collaboration-item">
                  <div className="collaboration-icon">
                    {point.icon}
                  </div>
                  <div className="collaboration-content">
                    <h4 className="collaboration-title">{point.title}</h4>
                    <p className="collaboration-description">{point.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partnership;
